import axios, { AxiosError } from 'axios';
import { message } from 'antd';
import { ResponseCode } from '../../services/enums/respondeCode.enum';

interface ServiceDetailError {
  backend: string;
  mensaje: string;
  severidad: string;
  status: string;
}

export interface ServiceError {
  codigo: string;
  descripcion: string;
  detalle?: ServiceDetailError;
}

export interface AxiosErrorResponse {
  errores: Array<ServiceError>;
  message: string;
}

const DEFAULT_ERROR_MESSAGE = 'Ocurrió un error inesperado. Estamos trabajando para resolverlo lo antes posible. Por favor, inténtalo nuevamente más tarde.';

const parseXmlError = (data: unknown): string | null => {
  if (typeof data !== 'string' || !data.includes('<errores>')) return null;

  try {
    const parser = new DOMParser();
    const xml = parser.parseFromString(data, 'text/xml');
    const codigo = xml.querySelector('codigo')?.textContent ?? '';
    const descripcion = xml.querySelector('descripcion')?.textContent ?? '';
    const mensaje = xml.querySelector('mensaje')?.textContent ?? '';
    return `${codigo} - ${descripcion}${mensaje ? ` ${mensaje}` : ''}`;
  } catch {
    return null;
  }
};

export const getError = (error: AxiosError<AxiosErrorResponse> | unknown): string => {
  if (!axios.isAxiosError(error)) {
    message.error(DEFAULT_ERROR_MESSAGE);
    return DEFAULT_ERROR_MESSAGE;
  }

  const { response } = error;

  if (response?.data?.errores?.length) {
    const { codigo, descripcion, detalle } = response.data.errores[0];

    const backendMessage = `${codigo} - ${descripcion ?? ''}${detalle ? ` ${detalle.mensaje}` : ''}`;

    message.error(backendMessage, 6);

    return backendMessage;
  }

  const xmlMessage = parseXmlError(response?.data);
  if (xmlMessage) {
    message.error(xmlMessage, 6);
    return xmlMessage;
  }

  const fallbackMessage =
    response?.data?.message ||
    ResponseCode[`STATUS_${response?.status}` as keyof typeof ResponseCode] ||
    DEFAULT_ERROR_MESSAGE;

  message.error(fallbackMessage);

  return fallbackMessage;
};

